"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = randomSeededArray;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _md = _interopRequireDefault(require("md5"));
var _hash = require("../hash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function randomSeededArray(userId, arr) {
  var accumulator = {};
  // Create a map of the array at it's index values to replace in place later.
  var map = arr.reduce(function (acc, val, i) {
    acc[i] = val;
    return acc;
  }, accumulator);
  // Our new random array
  var shuffled = [];
  // We are not actually modifying the array so we maintain a proxy for the length.
  var length = arr.length;
  arr.forEach(function () {
    var userHash = (0, _hash.hashStringToInt)((0, _md.default)(userId + length));
    var lastIndex = length - 1;
    var randomIndex = userHash % length;
    shuffled.push(map[randomIndex]);
    // Swap the random index with the number in the last index, so that it will not be selected again.
    map[randomIndex] = map[lastIndex];
    length -= 1;
  });
  return shuffled;
}